import { Trans, TransProps } from 'react-i18next';

import { useTranslate } from '@growtherapy/i18n';

import { NS_TELEHEALTH_CORE } from './constants';

interface TranslateProps extends Omit<TransProps<string>, 't' | 'ns'> {
  overrideNs?: string;
}

export function Translate({ i18nKey, values, components, overrideNs }: TranslateProps): JSX.Element {
  const t = useTranslate();

  return (
    <Trans t={t} i18nKey={i18nKey} values={values} components={components} ns={overrideNs ?? NS_TELEHEALTH_CORE} />
  );
}
